import type { Meta, StoryObj } from "@storybook/react";

import TaskBasicDetails from "@/ui/components/tasks/TaskBasicDetails";
import type { TaskBasicDetailsProps } from "@/ui/components/tasks/TaskBasicDetails";

const StoryMeta: Meta<TaskBasicDetailsProps> = {
  title: "Components/Tasks/TaskBasicDetails",
  component: TaskBasicDetails,
  argTypes: {
    description: { control: "text" },
    duration: { control: "text" },
    patientName: { control: "text" },
    title: { control: "text" },
  },
  args: {
    duration: "30 minutes",
    testID: "task-basic-details",
    title: "Task Title",
  },
};

type Story = StoryObj<TaskBasicDetailsProps>;

const Primary: Story = {};

const FullDetails: Story = {
  args: {
    description:
      "Complete task details including patient information. This is a detailed description of the task. for testing",
    patientName: "Jane",
  },
};

const WithDescription: Story = {
  args: {
    description: "This is a detailed description of the task.",
  },
};

const WithPatientName: Story = {
  args: {
    patientName: "John",
  },
};

export { FullDetails, Primary, WithDescription, WithPatientName };
export default StoryMeta;
